import Facebook from "./images/facebook.png";
import { useClipboard } from "@vueuse/core";
import line from "./images/line.png";
import WhatsApp from "./images/WhatsApp.png";
import Instagram from "./images/instagram.png";
import Messenger from "./images/Messenger.png";
import x from "./images/x.png";
import ins from "./images/ins.png";
import Snapchat from "./images/Snapchat.png";

async function copyToClipboard(text) {
	console.log("复制");
	if (!import.meta.client) return;

	try {
		const { copy, isSupported } = useClipboard();

		if (!isSupported.value) {
			console.warn("当前浏览器不支持剪贴板API");
			return;
		}

		await copy(text);
		alert("分享链接已複製, 请前往App分享吧~");
	} catch (err) {
		console.error("复制失败:", err);
	}
}

export const useShare = ({ link, text, img }) => {
	const encodedURL = encodeURIComponent(link);
	const encodedText = encodeURIComponent(text);
	const encodeImg = encodeURIComponent(img);

	const defaultShare = async () => {
		await copyToClipboard(`${text} ${link}`);
	};

	const shareFacebook = () => {
		if (import.meta.client) {
			window.open("https://www.facebook.com/sharer.php?u=" + encodedURL, "_blank");
		}
	};
	const shareTwitter = () => {
		const twitterURL = `https://twitter.com/intent/tweet?text=${encodedText}&url=${encodedURL}`;
		if (import.meta.client) {
			window.open(twitterURL, "_blank");
		}
	};
	const shareLine = () => {
		const shareUrl = `https://social-plugins.line.me/lineit/share?url=${encodedURL}&text=${encodedText}&imageUrl=${encodeImg}`;
		if (import.meta.client) {
			window.open(shareUrl, "_blank");
		}
	};
	const shareWhatsApp = () => {
		const whatsappURL = `https://wa.me/?text=${text} ${link}`;
		if (import.meta.client) {
			window.open(whatsappURL, "_blank");
		}
	};
	const shareToInstagram = () => {
		const shareUrl = `https://www.instagram.com/create/story?link=${encodedURL}&caption=${encodedText}`;
		if (import.meta.client) {
			window.open(shareUrl, "_blank");
		}
	};

	// function shareToMessenger() {
	//     if (!isMobile()) return defaultShare();
	//     const shareUrl = `fb-messenger://share/?link=${encodedURL}&quote=${encodedText}`;
	//     if (import.meta.client) { window.open(shareUrl, '_blank'); }
	// }

	const shareToLinkedIn = () => {
		const shareUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodedURL}&title=${encodedText}`;
		if (import.meta.client) {
			window.open(shareUrl, "_blank");
		}
	};

	const shareToSnapchat = () => {
		const shareUrl = `https://www.snapchat.com/scan?attachmentUrl=${encodedURL}&text=${encodedText}`;
		if (import.meta.client) {
			window.open(shareUrl, "_blank");
		}
	};

	// function shareToTikTok() {
	//     const shareUrl = `https://www.tiktok.com/share?url=${encodedURL}&text=${encodedText}`;
	//     if (import.meta.client) { window.open(shareUrl, '_blank');
	// }

	return [
		{
			icon: Facebook,
			text: "Facebook",
			shareFn: defaultShare,
		},
		{
			icon: line,
			text: "Line",
			shareFn: shareLine,
		},
		{
			icon: WhatsApp,
			text: "WhatsApp",
			shareFn: shareWhatsApp,
		},
		{
			icon: Instagram,
			text: "Instagram",
			shareFn: shareToInstagram,
		},
		{
			icon: Messenger,
			text: "Messenger",
			shareFn: defaultShare,
		},
		{
			icon: x,
			text: "X",
			shareFn: shareTwitter,
		},
		{
			icon: ins,
			text: "Linkedin",
			shareFn: shareToLinkedIn,
		},
		{
			icon: Snapchat,
			text: "Snapchat",
			shareFn: shareToSnapchat,
		},
		// {
		//     icon: require('./images/tiktok.png'),
		//     text: 'Tiktok',
		//     shareFn: defaultShare
		// },
		// {
		//     icon: require('./images/rednote.png'),
		//     text: '小红书',
		//     shareFn: defaultShare
		// }
	];
};
